import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgxUploaderModule } from 'ngx-uploader-esb';

import { DayInputModule } from '../day-input/day-input.module';
import { PipesModule } from '../pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { DealDetailsComponent } from './components/deal-details/deal-details.component';
import { IsMoreDaysPipe } from './components/deal-details/is-more-days.pipe';
import { DealDetailsNewComponent } from './components/deal-details-new/deal-details-new.component';
import { TotalByPromisedListPipe } from './components/deal-details-new/total-by-promised-list.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    SharedModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatDialogModule,
    DayInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatDividerModule,
    ReactiveFormsModule,
    NgxUploaderModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    FormsModule,
    PipesModule,
    DealDetailsNewComponent,
    DealDetailsComponent,
    IsMoreDaysPipe,
    TotalByPromisedListPipe,
  ],
  exports: [DealDetailsComponent, DealDetailsNewComponent],
})
export class DealDetailsModule {}
